import React, { useEffect } from "react";
import { Button, Form, Input, message, Modal, Typography } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  CreateBeneficiary,
  createBeneficiary,
} from "../../actions/beneficiary/beneficiary";
import { useDispatch, useSelector } from "react-redux";
const { Text, Title } = Typography;
const ValidationSchema = yup.object().shape({
  beneficiary_name: yup.string().required("Beneficiary name is required"),
  ifsc_code: yup.string().required("Ifsc code is required"),
  email: yup.string().email().required("Email name is required"),
  account_number: yup.string().required("Account number is required"),
  bank_name: yup.string().required("Bank name is required"),
  primary_contact: yup
    .string()
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
    .required("Mobile number is required"),

  // address: yup.string().required(),
});
const BeneficiaryModal = ({
  cardData,
  addBeneficiary,
  setAddBeneficiary,
  setIsTransfer,
}) => {
  const dispatch = useDispatch();
  const beneficiaryCreateData = useSelector(
    (state) => state?.beneficiary?.createBeneficiaryData?.data,
  );
  // const beneficiaryDataByID = useSelector((state) => state?.beneficiary?.beneficiaryDataByID?.data?.response?.beneficiary);
  const formik = useFormik({
    initialValues: {
      ifsc_code: "",
      beneficiary_name: "",
      account_number: "",
      bank_name: "",
      email: "",
      address: "",
      primary_contact: "",
    },
    onSubmit: (vals) => {
      // Destructure and initialize bank_account_details directly
      const { account_number, bank_name, ifsc_code, ...rest } = vals;
      let bank_account_details = { account_number, bank_name, ifsc_code };

      // Update vals to exclude the removed properties
      vals = rest;
      dispatch(
        createBeneficiary({
          ...vals,
          bank_account_details,
          card_id: cardData?.id,
        }),
      );
    },
    validationSchema: ValidationSchema,
  });

  const handleCancel = () => {
    setAddBeneficiary(false);
    setIsTransfer({ open: true, type: "bank_account" });
  };

  useEffect(() => {
    if (beneficiaryCreateData?.status) {
      setAddBeneficiary(false);
      setIsTransfer({ open: true, type: "bank_account" });
      dispatch({ type: CreateBeneficiary?.RESET });
      formik.resetForm({});
    } else if (beneficiaryCreateData?.status == false) {
      dispatch({ type: CreateBeneficiary?.RESET });
    }
  }, [beneficiaryCreateData]);

  return (
    <>
      {addBeneficiary && (
        <Modal
          title={<Title level={4}>{"Create Beneficiary"}</Title>}
          open={addBeneficiary}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal"
        >
          <Form onFinish={formik.handleSubmit} layout="vertical">
            <Form.Item
              label="Beneficiary Name"
              help={formik?.submitCount > 0 && formik.errors.beneficiary_name}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.beneficiary_name &&
                formik.touched.beneficiary_name
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter name"
                name="beneficiary_name"
                value={formik.values.beneficiary_name}
                onChange={formik.handleChange}
              />
            </Form.Item>
            <Form.Item
              label="Account No"
              help={formik?.submitCount > 0 && formik.errors.account_number}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.account_number &&
                formik.touched.account_number
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter account number"
                name="account_number"
                value={formik.values.account_number}
                onChange={formik.handleChange}
                onPaste={(event) => {
                  event.preventDefault();
                  formik.setFieldValue(
                    "account_number",
                    formik.values.account_number,
                  );
                }}
              />
            </Form.Item>
            <Form.Item
              label="IFSC Code"
              help={formik?.submitCount > 0 && formik.errors.ifsc_code}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.ifsc_code &&
                formik.touched.ifsc_code
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter ifsc"
                name="ifsc_code"
                value={formik.values.ifsc_code}
                onChange={formik.handleChange}
              />
            </Form.Item>
            <Form.Item
              label="Bank Name"
              help={formik?.submitCount > 0 && formik.errors.bank_name}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.bank_name &&
                formik.touched.bank_name
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter bank name"
                name="bank_name"
                value={formik.values.bank_name}
                onChange={formik.handleChange}
              />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              help={formik?.submitCount > 0 && formik.errors.primary_contact}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.primary_contact &&
                formik.touched.primary_contact
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter mobile"
                name="primary_contact"
                value={formik.values.primary_contact}
                onChange={formik.handleChange}
              />
            </Form.Item>
            <Form.Item
              label="Email Address"
              help={formik?.submitCount > 0 && formik.errors.email}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.email &&
                formik.touched.email
                  ? "error"
                  : "success"
              }
              required
            >
              <Input
                placeholder="Enter email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
              />
            </Form.Item>
            <Form.Item
              label="Address"
              help={formik?.submitCount > 0 && formik.errors.address}
              validateStatus={
                formik?.submitCount > 0 &&
                formik.errors.address &&
                formik.touched.address
                  ? "error"
                  : "success"
              }
            >
              <Input
                placeholder="Enter address"
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
              />
            </Form.Item>

            <div>
              <Button
                key="1"
                htmlType="submit"
                className="formButton mt3 primaryButton"
              >
                {"Submit"}
              </Button>
              <Button
                key="2"
                className="cancelButton ml1 mt3 "
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default BeneficiaryModal;
